import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import Homepage3 from '../HomePage3'
import AboutPage from '../AboutPage'
import ServicePage from '../ServicePage'
import ServicePageS2 from '../ServicePageS2'
import ServiceSinglePage from '../ServiceSinglePage'
import ProjectPage from '../ProjectPage'
import ProjectPageS2 from '../ProjectPageS2'
import ProjectSinglePage from '../ProjectSinglePage'
import PricingPage from '../PricingPage'
import TestimonialPage from '../TestimonialPage'
import BlogPage from '../BlogPage'
import BlogPageLeft from '../BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth'
import BlogDetails from '../BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull'
import ErrorPage from '../ErrorPage'
import ContactPage from '../ContactPage'
import LoginPage from '../LoginPage'
import SignUpPage from '../SignUpPage'
import ForgotPassword from '../ForgotPassword'
import MisionVisionPage from '../MisionVisionPage';
import PoliticaPage from '../PoliticaPage';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Homepage3 />} />
          <Route path='/about' element={<AboutPage/>} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/mision-vision' element={<MisionVisionPage />} />
          <Route path='/politica-privacidad' element={<PoliticaPage />} />

          {/* <Route path='/service' element={<ServicePage/>} />
          <Route path='/service-s2' element={<ServicePageS2/>} />
          <Route path='/service-single' element={<ServiceSinglePage />} />
          <Route path='/project' element={<ProjectPage />} />
          <Route path='/project-s2' element={<ProjectPageS2 />} />
          <Route path='/project-single' element={<ProjectSinglePage />} />
          <Route path='/pricing' element={<PricingPage />} />
          <Route path='/testimonial' element={<TestimonialPage />} />
          <Route path='/404' element={<ErrorPage />} />
          <Route path='/blog' element={<BlogPage />} />
          <Route path='/blog-left-sidebar' e
          lement={<BlogPageLeft />} />
          <Route path='/blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='/blog-single' element={<BlogDetails />} />
          <Route path='/blog-single-left-sidebar' element={<BlogDetailsLeftSiide />} />
          <Route path='/blog-single-fullwidth' element={<BlogDetailsFull />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/register' element={<SignUpPage />} />
          <Route path='/forgot-password' element={<ForgotPassword />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
